<template>

    <div style="position: relative">

        <div class="d-flex">

            <b-input-group class="f-1">

                <b-form-input autocomplete="off" aria-label="Search users in CareExchange" :placeholder=" placeholder " min="2"
                    v-model=" filter " @input=" onSearch " @focus=" showResults() " @blur=" hideResults() "
                    :disabled=" isDisabled ">
                </b-form-input>

                <b-input-group-append style="min-width: 135px" v-if=" !onlyOfficeUsers && !carrierBased ">

                    <b-button :variant=" searchVariant " @click=" toggleActiveFilter() " style="width: 100%">{{
                    searchText }}</b-button>
                </b-input-group-append>
                <template v-slot:prepend v-if=" !onlyOfficeUsers ">

                    <b-dropdown :text=" filterByText " variant="info" style="width: 95px">

                        <b-dropdown-item @click=" chooseFilter( 'name'   ) ">Name/Email</b-dropdown-item>
                        <b-dropdown-item @click=" chooseFilter( 'phone'  ) ">Phone Number</b-dropdown-item>
                        <b-dropdown-item @click=" chooseFilter( 'upd'    ) ">UPD ID</b-dropdown-item>
                        <b-dropdown-item @click=" chooseFilter( 'agency' ) ">Agency Name</b-dropdown-item>
                        <b-dropdown-item @click=" chooseFilter( 'policy' ) ">Policy/Claim Number</b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-input-group>

            <div v-if="carrierBased && !passesCarrier" class="ml-2" style="min-width: 250px">
                <carrier-dropdown v-model="carrier" :withEmpty="true" emptyText="-- Select Carrier --" :role=" role " />
            </div>
        </div>
        <div v-show=" isSearching " class="search-results" >
            <b-dropdown-item v-if="loading && this.filter != '' && this.filter.length >= 4" class="text-center mt-3"><i class="fa fa-spinner fa-spin fa-2x fa-fw" style="color:#26c6da"></i></b-dropdown-item>
            <b-dropdown-item v-if="this.filter.length <= 3">Minimum 4 characters are required for Search.</b-dropdown-item>
            <b-dropdown-item v-else-if=" options.length == 0  && !loading">{{ noResultsText }}</b-dropdown-item>
            <b-dropdown-item v-else v-for=" ( item, key ) in options " :key=" 'drop' + key + item.id "
                @click.prevent=" onClick( item ) ">

                <div class="d-flex align-items-center justify-content-between">

                    <p class="mb-0">{{ formatter( item ) }}</p>
                    <p :class=" activeClasses( item.active ) ">{{ activeText( item.active ) }}</p>
                </div>
            </b-dropdown-item>

        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';

export default {

    name: 'UserSearchDropdown',

    components: {

        'v-select': vSelect
    },

    props: {

        excludeManagers: {

            type: String,
            default: null,
            required: false
        },
        onlyOfficeUsers: {

            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'role'
        },
        role: {
            type: String
        },
        placeholder: {
            type: String,
            default: 'Search Clients and Providers',
        },
        icon: {
            type: String,
            default: 'fa-search',
        },
        noResultsText: {
            type: String,
            default: 'No Results',
        },
        clearOnSubmit: {
            type: Boolean,
            default: true,
        },
        formatter: {
            type: Function,
            default: (item) => {

                const role = item.role_type == 'office_user' ? 'LTCG' : item.role_type;
                return `${item.name} - ${_.join(_.map(_.split(role, '_'), function (val) { return _.capitalize(val); }), ' ')}` + (item.carrier ? ` - ${item.carrier}` : '');
            }
        },
        carrierBased: {
            type: Boolean,
            default: false,
        },
        passesCarrier: {

            type: Boolean,
            default: false
        },
        passedCarrier: {

            type: Number,
            default: null,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },

    data() {

        return {

            loading: false,
            isSearching: false,
            options: [],

            filterBy: 'name',
            activeFilter: true,
            filter: '',
            carrier: ''
        };
    },

    computed: {

        searchVariant() { return this.activeFilter ? 'info' : 'outline-info'; },
        searchText() { return this.activeFilter ? 'Active Only' : 'Active/Inactive'; },
        isDisabled() { return this.disabled || (this.carrierBased && !this.passesCarrier && !this.carrier) || (this.passesCarrier && this.passedCarrier == 0); },
        filterByText() { return this.filterBy.toUpperCase(); },
        appliedFilters() { return `&q=${this.filter}&active=${this.activeFilter}&filterBy=${this.filterBy}`; },
        computedCarrier() { return (this.passesCarrier && this.passedCarrier != 0 ? this.passedCarrier : this.carrier); }
    },

    methods: {

        chooseFilter(value) {

            this.filterBy = value;
        },
        activeText(active) {

            return active ? 'active' : 'inactive';
        },
        activeClasses(active) {

            const classes = ['mb-0'];
            classes.push((active ? 'text-blue' : 'text-danger'));
            return classes.join(' ');
        },
        toggleActiveFilter() {

            this.activeFilter = !this.activeFilter;
        },
        onSearch() {

            this.showResults();

            if (this.filter == '' && this.filter.length <= 3) {

                this.options = [];
                return;
            }
            this.loading = true;
            this.search(this);
        },

        search: _.debounce((vm) => {

            axios.get(`/search?type=${vm.type}&carrier=${vm.computedCarrier}&onlyOfficeUsers=${vm.onlyOfficeUsers}&excludeManagers=${vm.excludeManagers}${vm.appliedFilters}`)
                .then(response => {

                    vm.showResults();
                    vm.options = response.data.data || [];
                    vm.loading = false;
                })
                .catch(e => {

                    vm.showResults(false);
                    vm.options = [];
                    vm.loading = false;
                });
        }, 350),

        showResults(show = true) {

            if (this.filter == '') show = false;

            this.isSearching = show; 
        },

        hideResults() {

            setTimeout(function () {

                this.isSearching = false;
            }.bind(this), 200);
        },

        onClick(user) {

            if (this.clearOnSubmit) {

                this.filter = '';
                this.options = [];
            }

            this.$emit('selectUser', user);
        },
    },

    watch: {

        carrier(newValue, oldValue) {

            this.$emit('changeCarrier', newValue);
        },
        appliedFilters() {

            if (this.filter != '') this.search(this);
        }
    },
}
</script>

<style scoped>
.icon-control {
    position: relative;
    width: 100%;
    display: block;
    padding-top: 0px;
    padding-bottom: 0px;
}

.icon-control input {
    border: 0;
    color: #67757c;
    min-height: 38px;
    width: 90%;
}

.icon-control input::placeholder {
    color: #88979e;
}

.form-control.disabled {
    background-color: #e9ecef !important
}

.form-control.disabled input {
    background-color: #e9ecef !important
}
</style>